import { render, staticRenderFns } from "./cabinet-ktru-favorite-add-modal.vue?vue&type=template&id=36a93079&"
import script from "./cabinet-ktru-favorite-add-modal.vue?vue&type=script&lang=js&"
export * from "./cabinet-ktru-favorite-add-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a93079')) {
      api.createRecord('36a93079', component.options)
    } else {
      api.reload('36a93079', component.options)
    }
    module.hot.accept("./cabinet-ktru-favorite-add-modal.vue?vue&type=template&id=36a93079&", function () {
      api.rerender('36a93079', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/ktru/favorites/parts/cabinet-ktru-favorite-add-modal.vue"
export default component.exports